const mediaItems = [
  {
    title: '《流浪地球3》先导预告解析',
    desc: '深度解读最新预告中的隐藏彩蛋与剧情线索',
    tag: '热门解析',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20trailer%20scene%2C%20dramatic%20space%20station%20interior%20with%20warm%20glowing%20panels%2C%20film%20poster%20aesthetic%2C%20epic%20lighting%20with%20deep%20contrast%2C%20cinematic%20color%20grading&width=700&height=400&seq=media-scifi&orientation=landscape',
  },
  {
    title: '2026暑期档盘点：最值得看的十部电影',
    desc: '从动作片到动画电影，这份暑期观影指南请收好',
    tag: '观影指南',
    img: 'https://readdy.ai/api/search-image?query=Bright%20summer%20cinema%20collage%20aesthetic%20with%20warm%20sunset%20lighting%2C%20vintage%20film%20reels%20and%20popcorn%2C%20outdoor%20movie%20screen%20silhouette%2C%20vibrant%20and%20nostalgic%20atmosphere&width=700&height=400&seq=media-summer&orientation=landscape',
  },
  {
    title: '国产悬疑剧为什么越来越好看？',
    desc: '从剧本到演技，盘点近年国产悬疑剧的崛起之路',
    tag: '深度影评',
    img: 'https://readdy.ai/api/search-image?query=Moody%20film%20noir%20inspired%20scene%20with%20detective%20desk%2C%20warm%20desk%20lamp%20casting%20dramatic%20shadows%2C%20vintage%20typewriter%20and%20case%20files%2C%20rich%20contrast%20lighting%2C%20cinematic%20atmosphere&width=700&height=400&seq=media-mystery&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              影视资讯
            </h2>
            <p className="text-foreground-500 text-sm">最新影评解析与观影指南，不错过每一部好片</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {mediaItems.map((item, i) => (
              <div
                key={i}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer transition-all duration-300 hover:border-primary-200"
              >
                <div className="relative aspect-video overflow-hidden bg-background-200">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                    <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:scale-110 transition-transform duration-300">
                      <i className="ri-play-fill text-2xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute top-3 left-3">
                    <span className="inline-block px-2.5 py-1 bg-accent-500/90 text-background-50 text-xs font-medium rounded-md">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-semibold text-foreground-900 text-sm mb-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}